// action
import {
    GET_PAGE_CONTENT_DETAIL,
    GET_PAGE_CONTENT_DETAIL_FAIL,
    GET_PAGE_CONTENT_DETAIL_SUCCESS,
    GET_PAGE_CONTENT_DETAIL_RESET
} from '../action/getPageContentDetailAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PAGE_CONTENT_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_PAGE_CONTENT_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_PAGE_CONTENT_DETAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_PAGE_CONTENT_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}